module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container vh-container"
  }, [_c('osm-map', {
    attrs: {
      "markers": this.markers,
      "noEmptyMessage": true,
      "search": true,
      "filters": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e206ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Worldmap.vue
// module id = 440
// module chunks = 1